import { combineReducers } from "redux";

const USER = (state = true, action) => {
    switch (action.type) {
        case "LOGIN":
        case "LOGOUT":
        case "REGISTER":
            return true;
        case "USER_FOUND":
        case "NO_USER_FOUND":
        case "FORM_FAIL":
            return false;
        default:
            return state;
    }
};

const CURRENT_USER = (state = true, action) => {
    switch (action.type) {
        case "USER_FOUND":
            return true;
        case "GET_CURRENT_USER_RESPONSE":
        case "NO_USER_FOUND":
        case "LOGOUT":
            return false;
        default:
            return state;
    }
};

const PERMISSIONS = (state = true, action) => {
    switch (action.type) {
        case "USER_FOUND":
            return true;
        case "LOGOUT":
        case "NO_USER_FOUND":
        case "GET_PERMISSIONS_RESPONSE":
            return false;
        default:
            return state;
    }
};

const USER_SUBJECTS = (state = true, action) => {
    switch (action.type) {
        case "USER_FOUND":
            return true;
        case "LOGOUT":
        case "NO_USER_FOUND":
        case "GET_USER_SUBJECTS_RESPONSE":
            return false;
        default:
            return state;
    }
};

const resources = combineReducers({
    USER,
    CURRENT_USER,
    PERMISSIONS,
    USER_SUBJECTS
});

export { resources };



// WEBPACK FOOTER //
// ./src/store/reducers/resources.js